define('app/timing',[],function () {
    $(window).on('beforeunload', function() {
        document.cookie = 'stcontextid=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    });
});
